import Image from 'next/image';
import { useRef } from 'react';

import { FormattedMessage } from '@flipster/i18n';
import { observeIntersectionOnce, useIntersection } from '@flipster/react/misc/browser/intersection';
import { css } from '@flipster/styled-system/css';
import { stack } from '@flipster/styled-system/patterns';
import loadingBar from '@flipster/ui/assets/images/competition/loading-bar.png';
import segment from '@flipster/utils/segment';
import { CompetitionsEvent } from '@flipster/utils/segment/events/competitions';

export const CollectingResults = () => {
  const ref = useRef<HTMLDivElement>(null);
  useIntersection(
    ref,
    observeIntersectionOnce(() => {
      segment.track(CompetitionsEvent.CompetitionLandingViewPageScroll, {
        section_title: 'Collecting Results',
      });
    }),
  );
  return (
    <section
      className={stack({
        w: '100%',
        m: {
          base: '40px 0',
          tablet: '120px 0',
        },
        '& > p': {
          textStyle: 'Title/S',
          textAlign: 'center',
        },
      })}
    >
      <p>
        <FormattedMessage id='Autogen_common.r251126.s_Hang_on_for_the_leaderboard' />
      </p>
      <p>
        <FormattedMessage id='Autogen_common.r251126.s_We_re_collecting_sufficient_results' />
      </p>
      <Image
        src={loadingBar}
        alt='collecting-results'
        width={279}
        height={31}
        className={css({
          m: '0 auto',
          tabletDown: {
            w: 140,
            h: 16,
            mt: 18,
          },
          tablet: {
            mt: 30,
          },
        })}
      />
    </section>
  );
};
